const ERROR_MESSAGE = 'Something went wrong';
const SIGN_IN_ERROR_MESSAGE = 'Something went wrong with sign in';
const SIGN_UP_ERROR_MESSAGE = 'Something went wrong with sign up';
const CONFIRM_EMAIL_ERROR_MESSAGE = 'Please try again';
const ACCESS_FORBIDDEN_ERROR_MESSAGE =
  'You are not authorized to access this page';

export {
  ACCESS_FORBIDDEN_ERROR_MESSAGE,
  CONFIRM_EMAIL_ERROR_MESSAGE,
  ERROR_MESSAGE,
  SIGN_IN_ERROR_MESSAGE,
  SIGN_UP_ERROR_MESSAGE,
};
